<section>
    <div class="scroll-container" #scrollContainer (scroll)="onScroll($event)">
        <div nz-row>
            <div nz-col nzSpan="18">
                <div class="heading-fs-18 mb-0">
                    <span nz-icon nzType="arrow-left" nzTheme="outline" class="drawer-back-arrow mr-2 disp-mob"
                        (click)="cancel()"></span>
                    All Playlists
                </div>
            </div>
            <div nz-col nzSpan="6" class="text-right pt-2 disp-web">
                <span nz-icon nzType="close" nzTheme="outline" class="cursor-pointer" (click)="cancel()"></span>
            </div>
            <div nz-col nzSpan="24">
                <nz-divider></nz-divider>
            </div>
        </div>
        <div nz-row>
            <div nz-col nzSpan="24">
                <form nz-form>
                    <div class="d-flex">
                        <div class="w-100 mr-3">
                            <div class="input-container mt-2">
                                <nz-form-item class="mb-0">
                                    <nz-form-control class="drawer-search-input">
                                        <nz-input-group [nzPrefix]="prefixIcon" [nzSuffix]="suffixIcon">
                                            <input nz-input placeholder="Search Playlist" name="filterKey"
                                                [(ngModel)]="filterModel.filterKey" (keydown.enter)="onSearch()"
                                                (ngModelChange)="filterKeyChanged()" [maxlength]="100" [disabled]="!hasDisplayList"
                                                appAlphaNumericsLevelThree/>
                                        </nz-input-group>
                                        <ng-template #suffixIcon>
                                            <span nz-icon nzType="close" nzTheme="outline" *ngIf="filterModel.filterKey"
                                                (click)="clearSearch()" class="clear-search cursor-pointer"></span>
                                        </ng-template>
                                        <ng-template #prefixIcon>
                                            <span nz-icon nzType="search" nzTheme="outline" (click)="onSearch()"
                                                class="cursor-pointer"></span>
                                        </ng-template>
                                    </nz-form-control>
                                </nz-form-item>
                            </div>
                        </div>
                        <div class="text-right mt-1">
                            <button nz-button nzType="primary" type="button" class="mt-2"
                                (click)="openDisplaylistUpsertDrawer()">
                                <span nz-icon nzType="plus" nzTheme="outline"></span>Add New
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>

        <div nz-col nzSpan="24" *ngIf="isModelLoaded && hasDisplayList && model && model.length > 0">
            <div nz-row class="mt-2">
                <div nz-col nzSpan="24" class="mb-3">
                    <div class="d-flex justify-content-end cursor-pointer">
                        <nz-form-item class="sort-by-dropdown" *ngIf="model.length > 1">
                            <nz-form-control>
                                <nz-select nzPlaceHolder="Sort By" [(ngModel)]="sortOrder" name="sortOrder"
                                    (ngModelChange)="sortPlaylist()">
                                    <nz-option [nzValue]="'ascending'" nzLabel="Ascending"></nz-option>
                                    <nz-option [nzValue]="'descending'" nzLabel="Descending"></nz-option>
                                </nz-select>
                            </nz-form-control>
                        </nz-form-item>
                        <div class="align-center disp-web ml-2 action_sidebar_wrapper"
                            *ngIf="multiSelect && isPlaylistSelected">
                            <button nz-button type="button" [ngClass]="{'selected-button': isPlaylistSelected}"
                                (click)="done()">Add to Screen ({{ selectedItems.length }})</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div *ngIf="multiSelect && showMaxLimitWarning" class="mb-2" style="color: #faad14; font-size: 13px;">
            You can tag up to 10 playlists to screen(s).
        </div>

        <nz-spin [nzSpinning]="isLoading">
            <div *ngIf="isModelLoaded && model && model.length > 0">
                <div nz-row *ngFor="let item of model; trackBy: trackById" [nzGutter]="[16,16]"
                    (click)="selectPlaylist(item)" class="list-item mb-2 pt-1 cursor-pointer"
                    [class.selected-playlist-item]="multiSelect && item.isSelected">
                    <div nz-col [nzSpan]="multiSelect ? 2 : 0" *ngIf="multiSelect" class="d-flex align-items-center">
                        <label nz-checkbox [(ngModel)]="item.isSelected"
                            (ngModelChange)="onCheckboxToggle(item, $event)"
                            (click)="$event.stopPropagation()"></label>
                    </div>
                    <div nz-col [nzSpan]="multiSelect ? 14 : 16">
                        <div class="d-flex align-items-center cursor-pointer">
                            <div class="list-img-wrapper mr-3 cursor-pointer"
                                (click)="$event.stopPropagation(); previewPlaylistInModal(item)"
                                nz-tooltip nzTooltipTitle="Preview">
                                <img *ngIf="item.thumbnailUrl" [src]="item.thumbnailUrl" alt="" (error)="onImageError($event)">
                                <ng-container *ngIf="!item.thumbnailUrl">
                                    <img class="theme-img-light" [src]="item.defaultUserMediaAppUrl" alt="" (error)="onImageError($event)">
                                    <img class="theme-img-dark" [src]="item.defaultUserMediaAppUrlDark" alt=""
                                        (error)="$any($event.target).src = item.defaultUserMediaAppUrl">
                                </ng-container>
                            </div>
                            <span class="text-ellipsis">{{item.name}}</span>
                        </div>
                    </div>
                    <div nz-col nzSpan="8" class="align-items-center">
                        {{item.userMediaAppCount}} media
                    </div>
                    <nz-divider class="mt-1 mb-0"></nz-divider>
                </div>
            </div>
            <div *ngIf="isModelLoaded && model && model.length == 0 && hasDisplayList" class="empty-list-container">
                <span class="text-muted fs-14">No playlist match your search</span>
            </div>
            <div *ngIf="isModelLoaded && !hasDisplayList" class="empty-list-container">
                <span class="text-muted fs-14">No playlist found</span>
            </div>
        </nz-spin>

        <div nz-row class="disp-mob mobOne-action-bar action_sidebar_wrapper"
            *ngIf="multiSelect && isModelLoaded && hasDisplayList && model && model.length > 0">
            <div nz-col nzSpan="24">
                <nz-card>
                    <div nz-row [nzGutter]="[16]">
                        <div nz-col nzSpan="24">
                            <button nz-button type="button" class="btn-full"
                                [ngClass]="{'selected-button': isPlaylistSelected}"
                                [disabled]="!isPlaylistSelected"
                                (click)="done()">Add to Screen ({{ selectedItems.length }})</button>
                        </div>
                    </div>
                </nz-card>
            </div>
        </div>
        <nz-drawer #drawer [nzClosable]="false" nzPlacement="right" (nzOnClose)="close()" [nzMask]="false"
            class="custom-drawer">
            <ng-container *nzDrawerContent>
                <app-display-list-upsert (closeDrawer)="closeDisplayUpsertDrawer($event)"
                    [addFromDisplay]="addFromDisplay" *ngIf="addDisplayList"
                    [selectedGroupId]="groupId"></app-display-list-upsert>
            </ng-container>
        </nz-drawer>
    </div>
</section>